import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import MerchantsList from "../../components/Merchant";

const MerchantsPage = (): ReactElement => {
  return (
    <Layout>
      <MerchantsList />
    </Layout>
  );
};

export default MerchantsPage;
